<template>
  <div class="community-profile-popover p-2">
    <div
      class="d-flex align-items-center mb-3 cursor-pointer"
      @click="$emit('open')"
    >
      <img v-if="user.picture" :src="user.picture" class="user-picture mr-2" />
      <h6 class="mb-0">
        {{ user.name }}
      </h6>
    </div>

    <table>
      <tr>
        <td><img class="img-icon" src="@/assets/images/small-logo.svg" /></td>
        <td>Entrou em {{ createdAt }}</td>
      </tr>
      <tr v-if="user.temper">
        <td><img class="img-icon" :src="temperImage" /></td>
        <td>{{ temperName }}</td>
      </tr>
      <tr v-if="user.occupation">
        <td><i class="fas fa-fw fa-briefcase"></i></td>
        <td>{{ user.occupation }}</td>
      </tr>
      <tr
        v-if="
          user.localization && user.localization.city && user.localization.state
        "
      >
        <td><i class="fas fa-fw fa-map-marker-alt"></i></td>
        <td>
          Mora em {{ user.localization.city }}, {{ user.localization.state }}
        </td>
      </tr>
      <tr>
        <td><i class="fas fa-fw fa-pencil-alt"></i></td>
        <td>
          {{ user.count_topic }} tópico{{ user.count_topic === 1 ? "" : "s" }}
        </td>
      </tr>
    </table>

    <div v-if="user.phone" class="text-right">
      <hr />
      <a
        :href="`https://api.whatsapp.com/send?phone=${user.phone}`"
        target="_blank"
        class="btn btn-success rounded-pill px-4"
      >
        <i class="fab fa-whatsapp fa-lg"></i> WHATSAPP
      </a>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    user: Object
  },
  computed: {
    temperImage() {
      const temper = this.user.temper || "todos";
      return require(`../../assets/images/temperamentos/${temper}.svg`);
    },
    temperName() {
      return {
        colerico: "Colérico",
        melancolico: "Melancólico",
        fleumatico: "Fleumático",
        sanguineo: "Sanguíneo"
      }[this.user.temper];
    },
    createdAt() {
      const dateString = this.user.created_at;
      return dayjs(dateString)
        .locale("pt")
        .format("MMMM [de] YYYY");
    }
  }
};
</script>

<style lang="scss" scoped>
.community-profile-popover {
  .user-picture {
    max-height: 48px;
    max-width: 48px;
    min-height: 48px;
    min-width: 48px;
    border-radius: 48px;
  }

  h6 {
    font-size: 18px;
    font-weight: 500;
  }

  i {
    margin-right: 4px;
  }

  .img-icon {
    height: 20px;
    width: 17px;
    object-fit: contain;
    margin-right: 4px;
  }

  hr {
    border-color: rgba(255, 255, 255, 0.2);
  }

  .btn {
    font-size: 14px;
    font-weight: 500;
  }

  table {
    color: #bbb;

    i {
      color: white;
    }
  }
}
</style>
